module.exports = __webpack_public_path__ + "static/media/dosing.fd5b16a3.webp";